import React from "react";
import { art } from "./config";

const STEPS = [
  {
    n: "01",
    label: "Talk",
    title: "Your child just talks.",
    body: "No typing, no reading, no menus. Tap once and chat. I listen properly, wait while they think, and stop the moment they jump in.",
    img: "leo-standing-600.png",
    tint: "#FFE1C4",
    speech: "What shall we do today?",
  },
  {
    n: "02",
    label: "Teach",
    title: "I get stuck. They explain.",
    body: "I muddle my sevens and forget how to carry the one. Your child puts me right — and saying it out loud is when it really clicks for them.",
    img: "leo-thinking-600.png",
    tint: "#DDE8F8",
    speech: "Hmm… is it 54?",
  },
  {
    n: "03",
    label: "Grow",
    title: "I remember. I build on it.",
    body: "I know what they've nailed and what's still wobbly, and pick the next step from the curriculum for their year. Every chat starts where the last one ended.",
    img: "leo-smiling-600.png",
    tint: "#D6EEDF",
    speech: "You smashed your 6s!",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="section" data-testid="how-section">
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow rv">How it works</span>
          <h2 className="h2 rv" style={{ "--d": "80ms" }}>
            The best way to learn something is to <span className="said">teach it.</span>
          </h2>
          <p className="lede rv" style={{ "--d": "160ms" }}>
            So that's the whole idea. Your child is never the one being tested — they're the one
            helping. It feels like play, because it is.
          </p>
        </div>

        <div className="steps">
          {STEPS.map((s, k) => (
            <article className="step rv" style={{ "--d": `${k * 120}ms`, "--tint": s.tint }} key={s.n}>
              <span className="step-num">
                <b>{s.n}</b> / {s.label}
              </span>
              <h3>{s.title}</h3>
              <p>{s.body}</p>
              <div className="step-art">
                <span className="step-speech">{s.speech}</span>
                <img src={art(s.img)} alt="" loading="lazy" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
